// Script para recolectar colores de productos y generar filtros dinámicos
// Global para almacenar los colores detectados
window.shopifyProductColors = {
    colors: [],  // Almacenará los colores únicos encontrados
    validColors: [], // Almacenará solo colores válidos con códigos de color
    initialized: false,  // Indica si el script ya ha sido inicializado
    
    // Función para inicializar la recolección de colores
    init: function() {
      if (this.initialized) return;
      
      //console.log('Iniciando recolección de colores de productos...');
      this.collectColorsFromProducts();
      this.initialized = true;
    },
    
    // Función para estandarizar formato de colores
    standardizeColorFormat: function(colorName) {
      if (!colorName) return '';
      
      // Primero normalizamos quitando caracteres no deseados y espacios extra
      var normalized = colorName.trim()
        .replace(/[-_]/g, ' ')    // Reemplazar guiones y guiones bajos con espacios
        .replace(/\s+/g, ' ');    // Reemplazar múltiples espacios con uno solo
      
      // Luego capitalizamos cada palabra
      return normalized.split(' ').map(function(word) {
        return word.charAt(0).toUpperCase() + word.slice(1).toLowerCase();
      }).join(' ');
    },
    
    // Función para recolectar colores de los productos en la página
    collectColorsFromProducts: function() {
      var self = this;
      var colorMap = {};  // Usamos un objeto para evitar duplicados
      
      // 1. Buscar en atributos de datos de productos
      var productElements = document.querySelectorAll('[data-product-id], [data-product-handle], .tt-product, .tt-product-design02');
      
      productElements.forEach(function(product) {
        // Buscar elementos con información de color dentro del producto
        var colorElements = product.querySelectorAll('[data-color], [data-option-color], .color-options [data-color]');
        
        colorElements.forEach(function(element) {
          var colorValue = element.getAttribute('data-color');
          
          if (colorValue) {
            // Aplicamos el formato estándar
            var formattedColor = self.standardizeColorFormat(colorValue);
            
            // Verificar que sea un color válido (no código, no texto de javascript)
            if (self.isValidColorName(formattedColor)) {
              // Almacenar el color con formato estandarizado
              if (!colorMap[formattedColor]) {
                colorMap[formattedColor] = true;
              }
            }
          }
        });
      });
      
      // 2. Añadimos colores predeterminados en caso de que no encontremos nada
      var defaultColors = ['Negro', 'Ivory', 'Azul Marino'];
      defaultColors.forEach(function(color) {
        if (!colorMap[color]) {
          colorMap[color] = true;
        }
      });
      
      // Convertir el mapa de colores a un array
      this.colors = Object.keys(colorMap);
      
      // Filtrar solo colores válidos (que tengan un código hex asociado)
      this.validColors = this.colors.filter(function(color) {
        return getColorHexCode(color.toLowerCase()) !== '#cccccc'; // Si devuelve el color por defecto, probablemente no es un color válido
      });
      
      //console.log('Colores encontrados en productos:', this.validColors);
      
      // Crear/actualizar los filtros de color
      this.updateColorFilters();
    },
    
    // Verifica si un string es un nombre de color válido
    isValidColorName: function(colorName) {
      if (!colorName) return false;
      
      // Convertir a minúsculas para la comparación
      var lowerColor = colorName.toLowerCase();
      
      // Lista de términos que indican que no es un color válido
      var invalidTerms = [
        'function', 'var', 'let', 'const', 'document', 'queryselector', 
        'foreach', 'console', 'background', 'style', 'options', 'image', 
        'tooltip', '.', '{', '}', '(', ')', ';', '=', '+', '"', "'", '<', '>'
      ];
      
      // Si contiene alguno de estos términos, no es un color válido
      for (var i = 0; i < invalidTerms.length; i++) {
        if (lowerColor.includes(invalidTerms[i])) {
          return false;
        }
      }
      
      // Verificar longitud (los nombres de color válidos suelen ser cortos)
      if (colorName.length > 25) {
        return false;
      }
      
      return true;
    },
    
    // Función para actualizar los filtros de color
    updateColorFilters: function() {
      // Si no hay colores o estamos en otra página que no es de búsqueda, no hacer nada
      if (this.validColors.length === 0 || 
          !(window.location.pathname.includes('/search') || window.location.search.includes('q='))) {
        return;
      }
      
      //console.log('Actualizando filtros de color con los colores encontrados...');
      
      // Buscar la sección de filtros de color existente o crearla
      var sidebar = document.querySelector('.tt-collapse-content');
      if (!sidebar) {
        //console.error('No se pudo encontrar el contenedor del sidebar');
        return;
      }
      
      var colorSection = document.querySelector('.color-filter-section');
      var isNewSection = false;
      
      if (!colorSection) {
        //console.log('Creando nueva sección de filtros de color...');
        colorSection = document.createElement('div');
        colorSection.className = 'tt-options-swatch color-filter-section';
        isNewSection = true;
      }
      
      // Aplicar estilos forzados
      colorSection.style.display = 'block';
      colorSection.style.visibility = 'visible';
      colorSection.style.opacity = '1';
      colorSection.style.marginBottom = '25px';
      
      // Obtener parámetros actuales de la URL
      var urlParams = new URLSearchParams(window.location.search);
      var searchTerm = urlParams.get('q') || '';
      var sortBy = urlParams.get('sort_by') || '';
      var priceMin = urlParams.get('filter.v.price.gte') || '';
      var priceMax = urlParams.get('filter.v.price.lte') || '';
      var availability = urlParams.get('filter.v.availability') || '';
      var currentColor = urlParams.get('filter.v.option.color') || '';
      
      // Crear base de URL para los enlaces
      var baseUrl = window.location.pathname + '?q=' + encodeURIComponent(searchTerm);
      if (sortBy) baseUrl += '&sort_by=' + sortBy;
      if (priceMin) baseUrl += '&filter.v.price.gte=' + priceMin;
      if (priceMax) baseUrl += '&filter.v.price.lte=' + priceMax;
      if (availability) baseUrl += '&filter.v.availability=' + availability;
      
      // Generar HTML para la sección de colores
      var html = '<h4 class="filter-group-title">Color</h4>';
      html += '<ul class="options-swatch-color" style="display: flex; flex-wrap: wrap; gap: 8px; padding: 0; margin-top: 10px; list-style: none;">';
      
      this.validColors.forEach(function(color) {
        var hexColor = getColorHexCode(color.toLowerCase());
        var displayName = color; // Mantener la capitalización para mostrar
        
        // Para la comparación, normalizar ambos valores
        var normalizedCurrent = currentColor.replace(/\+/g, ' ').toLowerCase();
        var normalizedColor = color.toLowerCase();
        var isActive = normalizedCurrent === normalizedColor ? ' class="active"' : '';
        
        // Construir la URL manualmente para evitar problemas de codificación
        var colorForUrl = color.replace(/ /g, '+'); // Espacios a + (sin codificar)
        var fullUrl = baseUrl + '&filter.v.option.color=' + colorForUrl;
        
        html += '<li' + isActive + '>' +
                '<a href="' + fullUrl + '" ' +
                'class="options-color-filter" ' +
                'data-color="' + color + '" ' +
                'style="display: block; width: 30px; height: 30px; border-radius: 50%; border: 1px solid #ddd; position: relative; background-color: ' + hexColor + ';">' +
                '<span class="tooltip-color" style="display: none; position: absolute; background: #fff; color: #000; padding: 5px 10px; border-radius: 3px; font-size: 12px; bottom: 30px; left: 50%; transform: translateX(-50%); box-shadow: 0 0 5px rgba(0,0,0,0.2); white-space: nowrap; z-index: 10;">' + displayName + '</span>' +
                '</a>' +
                '</li>';
      });
      
      html += '</ul>';
      
      // Actualizar el contenido de la sección
      colorSection.innerHTML = html;
      
      // Si es una nueva sección, insertarla en el DOM
      if (isNewSection) {
        // Insertar antes del filtro de disponibilidad
        var stockFilter = sidebar.querySelector('.stock-filter');
        if (stockFilter) {
          sidebar.insertBefore(colorSection, stockFilter);
        } else {
          sidebar.appendChild(colorSection);
        }
      }
      
      // Añadir eventos para los tooltips
      var colorOptions = colorSection.querySelectorAll('.options-color-filter');
      colorOptions.forEach(function(option) {
        option.addEventListener('mouseenter', function() {
          var tooltip = this.querySelector('.tooltip-color');
          if(tooltip) {
            tooltip.style.display = 'block';
          }
        });
        
        option.addEventListener('mouseleave', function() {
          var tooltip = this.querySelector('.tooltip-color');
          if(tooltip) {
            tooltip.style.display = 'none';
          }
        });
      });
      
      //console.log('Filtros de color actualizados correctamente');
    }
  };
  
  // Función para mapear nombres de colores a códigos hexadecimales
  function getColorHexCode(colorName) {
    if (!colorName) return '#cccccc';
    
    // Convertir a minúsculas y quitar espacios para comparación
    var normalizedColor = colorName.toLowerCase().replace(/\s+/g, '');
    
    // Mapa de colores comunes y sus traducciones
    var colorMap = {
      // Colores en español
      'negro': '#000000',
      'blanco': '#ffffff',
      'rojo': '#ff0000',
      'verde': '#008000',
      'azul': '#0000ff',
      'amarillo': '#ffff00',
      'morado': '#800080',
      'naranja': '#ffa500',
      'rosa': '#ffc0cb',
      'marron': '#a52a2a',
      'gris': '#808080',
      'plateado': '#c0c0c0',
      'dorado': '#ffd700',
      'beige': '#f5f5dc',
      'marino': '#000080',
      'azulmarino': '#000080',
      'turquesa': '#40e0d0',
      'violeta': '#ee82ee',
      'ivory': '#fffff0',  // Marfil/Ivory
      
      // Colores en inglés
      'black': '#000000',
      'white': '#ffffff',
      'red': '#ff0000',
      'green': '#008000',
      'blue': '#0000ff',
      'yellow': '#ffff00',
      'purple': '#800080',
      'orange': '#ffa500',
      'pink': '#ffc0cb',
      'brown': '#a52a2a',
      'gray': '#808080',
      'grey': '#808080',
      'silver': '#c0c0c0',
      'gold': '#ffd700',
      'navy': '#000080',
      'navyblue': '#000080',
      'teal': '#008080',
      'maroon': '#800000',
      'olive': '#808000',
      'coral': '#ff7f50',
      'turquoise': '#40e0d0',
      'violet': '#ee82ee',
      
      // Colores específicos que vimos en la página
      'mushroom-negro': '#000000',
      'mushroom-ivory': '#fffff0'
    };
    
    // Si el color no está en el mapa, usamos un color por defecto
    var hexColor = colorMap[normalizedColor];
    
    // Si no encontramos el color exacto, buscamos coincidencias parciales
    if (!hexColor) {
      for (var key in colorMap) {
        if (normalizedColor.includes(key) || key.includes(normalizedColor)) {
          hexColor = colorMap[key];
          break;
        }
      }
    }
    
    return hexColor || '#cccccc'; // Color por defecto si no se encuentra
  }
  
  // Inicializar la recolección de colores cuando el DOM esté cargado
  document.addEventListener('DOMContentLoaded', function() {
    // Esperar un momento para que todos los componentes del tema estén cargados
    setTimeout(function() {
      window.shopifyProductColors.init();
    }, 500);
  });